module.exports = "<div style=\"min-width: 1024px; width: 100%;height: 100vh; overflow-y: hidden;\">\r\n  <iframe [src]=\"domSanitizer.bypassSecurityTrustResourceUrl(urlDestino+caminho)\" style=\"width: 100%; height: 100vh;\">\r\n  </iframe>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/app/area-cliente/portal/tela-suporte/tela-suporte.component.html
// module id = ../../../../../src/app/area-cliente/portal/tela-suporte/tela-suporte.component.html
// module chunks = 1